import { ROUTES } from '@/constants/routes'
import { useAuthContext } from '@/context'
import { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'

const AdminRoute = ({ component }: { component: ReactElement }) => {
    const { user } = useAuthContext()

    if (!user) {
        return <Navigate to='/login' />
    }

    if (!user.isAdmin) {
        return <Navigate to={ROUTES.DASHBOARD_ROOT} />
    }

    return component
}

export default AdminRoute
